var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3C59E4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.011,
    cy: 10.159,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.727 12.727a1.5 1.5 0 00.3 1.655l.055.054a1.818 1.818 0 11-2.573 2.573l-.054-.054a1.5 1.5 0 00-1.655-.3 1.5 1.5 0 00-.91 1.372v.155a1.818 1.818 0 11-3.635 0V18.1a1.5 1.5 0 00-.982-1.373 1.5 1.5 0 00-1.655.3l-.054.055a1.818 1.818 0 11-2.573-2.573l.054-.054a1.5 1.5 0 00.3-1.655 1.5 1.5 0 00-1.372-.91h-.155a1.818 1.818 0 110-3.635H1.9a1.5 1.5 0 001.373-.982 1.5 1.5 0 00-.3-1.655l-.055-.054A1.818 1.818 0 115.491 2.99l.054.054a1.5 1.5 0 001.655.3h.073a1.5 1.5 0 00.909-1.372v-.155a1.818 1.818 0 013.636 0V1.9a1.5 1.5 0 00.91 1.373 1.5 1.5 0 001.654-.3l.054-.055a1.818 1.818 0 112.573 2.573l-.054.054a1.5 1.5 0 00-.3 1.655v.073a1.5 1.5 0 001.372.909h.155a1.818 1.818 0 110 3.636H18.1a1.5 1.5 0 00-1.373.91z"
  }))));
}

export default __webpack_public_path__ + "./fonts/settings-icon.e7997e5834646ae2a6793a0fc2f452dc.svg";
export { SvgSettingsIcon as ReactComponent };